// import UserLayout from '@/layouts/UserLayout';

import { BlankLayout } from '@/layouts';

export default [
  {
    path: '/auth',
    component: BlankLayout,
    redirect: '/auth/login',
    hidden: true,
    children: [
      // {
      //   path: 'login',
      //   name: 'login',
      //   component: () => import('@/views/system/auth/login.vue'),
      // },
      // {
      //   path: 'register',
      //   name: 'register',
      //   component: () => import('@/views/system/auth/Register/index.vue'),
      // },
      // {
      //   path: 'register-result',
      //   name: 'registerResult',
      //   component: () => import('@/views/system/auth/RegisterResult/index.vue'),
      // },
    ],
  },
];
